import React, { useState, useMemo } from 'react';

import {
  SidePage,
  Button,
  Stack,
  Grid,
  SearchInput,
  Divider,
  Tooltip,
  MetricsPicker,
} from '@gogame/components';

import ApplyFiltersButton from 'scenes/RegsStats/Filters/ApplyFiltersButton';
import { useLoadMetrics } from 'scenes/RegsStats/data';

import { formatData } from './formatMetricsIntoGroups';

const RegsStatsColumnsPicker = ({
  value,
  open,
  onClose,
  onSubmit,
  onExited,
}) => {
  const [selected, setSelected] = useState(value);

  const { data, isLoading, isRefetching } = useLoadMetrics();

  const [searchQuery, setSearchQuery] = useState('');

  const handleClearAll = () => {
    setSelected([]);
  };

  const handleChangeMetrics = (e) => {
    setSelected(e);
  };

  const handleSubmit = (apply) => () => {
    onSubmit({ order: selected, apply });
  };

  const dirty = useMemo(() => {
    return selected.toString() !== value.toString();
  }, [selected]);

  const emptySelect = !selected.length;

  return (
    <SidePage
      size={'lg'}
      open={open}
      loading={isLoading}
      fetching={isRefetching}
      onClose={onClose}
      onExited={onExited}
    >
      <SidePage.Title title={'Customize Columns'} />
      <SidePage.NewBody disableGutters={true} dense={true} scroll={false}>
        <Stack p={2}>
          <SearchInput
            value={searchQuery}
            onChange={(_e, value) => {
              setSearchQuery(value);
            }}
          />
        </Stack>
        <Divider />
        <MetricsPicker
          grouped={true}
          searchQuery={searchQuery}
          selected={selected}
          metrics={data}
          onClearAll={handleClearAll}
          setSelected={handleChangeMetrics}
          formatData={formatData}
          filterField={'name'}
          getOptionLabel={({ name }) => name}
          getOptionMetricValue={({ id }) => id}
          numberOfGroupMaxSelectedItems={30}
        />
      </SidePage.NewBody>
      <SidePage.Actions>
        <Grid container justifyContent={'space-between'}>
          <SidePage.CloseButton />
          <Stack spacing={1} direction={'row'}>
            <Tooltip
              title={
                emptySelect ? 'Select at least one column' : 'Save filters'
              }
              placement={'bottom'}
            >
              <div>
                <Button
                  onClick={handleSubmit(false)}
                  disabled={!dirty || emptySelect}
                >
                  Save
                </Button>
              </div>
            </Tooltip>
            <ApplyFiltersButton
              tooltip={emptySelect ? 'Select at least one column' : undefined}
              onClick={handleSubmit(true)}
              dirty={dirty}
              disabled={emptySelect}
            />
          </Stack>
        </Grid>
      </SidePage.Actions>
    </SidePage>
  );
};

export default RegsStatsColumnsPicker;
